import richTextNodeToString from "./richTextNodeToString";

export default function getWordCountFromRichText(documentNode) {
  // Get Content as String
  const veryLongString = richTextNodeToString(documentNode, Number.MAX_SAFE_INTEGER) || "";
  // Clean, split, and count
  return veryLongString.length > 0
    ? veryLongString
        .replace(/\./gim, " ")
        .replace(/[^a-z0-9\s+]+/gi, "")
        .split(/\s+/).length
    : null;
}
